<template>
    <footer v-if="showFooter" class="relative pt-8 sm:pt-20 pb-8 bg-white border-t-2 border-black">
        <Container class="mb-12 md:mb-20">
            <div class="flex flex-wrap -mx-4">
                <div class="w-full lg:w-1/3 px-4 mb-6 lg:mb-0">
                    <Link class="inline-block mb-8 sm:mb-16" href="/" aria-label="Головна">
                        <ApplicationLogo class="max-h-12 w-24 sm:w-40"/>
                    </Link>

                    <Contacts/>
                </div>
                <div class="w-full lg:w-2/3 px-4" v-if="!registrationState">
                    <div class="flex flex-wrap justify-between -mx-4 -mb-8">
                        <LinksList class="w-full sm:w-1/2 lg:w-1/3 px-4 mb-8" title="Каталог"
                                   :links="catalogPages"/>
                        <LinksList class="w-full sm:w-1/2 lg:w-1/3 px-4 mb-8" title="Інфо" :links="infoPages"/>
                        <LinksList class="w-full sm:w-1/2 lg:w-1/3 px-4 mb-8" title="Продавцям"
                                   :links="sellerPages"/>
                        <!--                                <div class="w-full sm:w-1/2 lg:w-3/5 lg:ml-auto px-4 mb-8">-->
                        <!--                                    <h3 class="text-base font-black mb-6">Newsletter</h3>-->
                        <!--                                    <span class="block text-sm font-bold text-white mb-5"-->
                        <!--                                          >Lorem ipsum dolor sit amet, consectetur.</span>-->
                        <!--                                    <div class="xl:flex items-center max-w-xs lg:max-w-sm">-->
                        <!--                                        <input-->
                        <!--                                            class="h-12 w-full mb-4 xl:mb-0 xl:mr-3 pl-5 py-3 placeholder-white font-bold text-white border-2 border-white bg-black rounded-md focus:outline-green"-->
                        <!--                                            type="email" placeholder="Type your e-mail">-->
                        <!--                                        <button-->
                        <!--                                            class="inline-flex w-full xl:w-auto items-center justify-center h-12 py-1 px-6 text-base font-black text-black bg-green-500 hover:bg-green-600 border-2 border-black rounded-md transition duration-300"-->
                        <!--                                            type="submit">Subscribe-->
                        <!--                                        </button>-->
                        <!--                                    </div>-->
                        <!--                                </div>-->
                    </div>
                </div>
            </div>
        </Container>
        <div class="pt-6 border-t-2 border-black">
            <Container>
                <div class="flex items-center justify-between -mb-5">
                    <div class="mb-3">
                        <p class="text-sm font-bold">
                            © 2023 - {{ year }} Маркетплейс кави «КапКульт»
                        </p>
                    </div>
                    <div class="mb-3 flex items-center">
                        <Visa class="w-16 mr-5"/>
                        <Mastercard class="w-16"/>
                    </div>
                </div>

                <div class="pt-6 text-xs text-gray-500">
                    Ми вдосконалюємо наш сервіс та рекламу за допомогою Microsoft Clarity, щоб побачити, як ви використовуєте наш веб-сайт.
                    Користуючись нашим сайтом, ви погоджуєтесь, що ми та Microsoft можемо збирати та використовувати ці дані.
                    Наша <Link class="underline" :href="route('pages', 'privacy-policy')">політика конфіденційності</Link> містить докладнішу інформацію.
                </div>
            </Container>
        </div>
    </footer>
</template>

<script>
import {Link} from "@inertiajs/vue3";
import Visa from "@/Components/Svg/Visa.svg";
import LinksList from "@/Layouts/Partials/LinksList.vue";
import Mastercard from "@/Components/Svg/Mastercard.svg";
import ApplicationLogo from "@/Components/ApplicationLogo.vue";
import Container from "@/Components/Base/Container.vue";
import Contacts from '@/Layouts/Partials/Contacts.vue';

export default {
    components: { Contacts, Container, ApplicationLogo, Mastercard, LinksList, Visa, Link},
    props: {
        menu: Array,
        year: Number,
        infoPages: Array,
        sellerPages: Array,
        showFooter: Boolean,
        registrationState: Boolean,
    },
    data () {
        return {
            catalogPages: this.menu.map((category) => ({
                title: category.title,
                url: this.route('categories.show', {category})
            }))
        }
    }
}
</script>
